import type { TWebSocketState } from "./connection.types";

export const MAX_WEBSOCKET_TRIES =
  Number(import.meta.env.VITE_MAX_WEBSOCKET_TRIES) || 5;

export const webSocketInitialState: TWebSocketState = {
  idle: true,
  closed: false,
  error: false,
  loading: false,
  opened: false,
  tries: 0,
};
